import React from 'react';

// Strong, in-app confirmation shown when an action will invalidate a reconciliation
// (draft or finalized). Mirrors the duplicate-purchase modal style so it clearly
// grabs attention instead of using the weak native confirm() dialog.
// `data` = { status: 'draft' | 'finalized' } or null.
export default function InvalidateWarningModal({ data, onCancel, onConfirm }) {
  if (!data) return null;
  const finalized = data.status === 'finalized';
  return (
    <div className="modal-overlay">
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h2 style={{ color: 'var(--danger)' }}>
          ⚠️ {finalized ? 'Conciliación FINALIZADA' : 'Conciliación en borrador'}
        </h2>
        <p style={{ marginBottom: 12 }}>
          {finalized
            ? 'Este mes ya tiene una conciliación FINALIZADA. Esta acción la marcará como INVÁLIDA y reabrirá el mes (se quitará el bloqueo).'
            : 'Este mes ya tiene una conciliación en borrador. Esta acción la marcará como INVÁLIDA.'}
        </p>
        <p style={{ marginBottom: 16, color: 'var(--text-2)' }}>
          Tendrás que volver a generar{finalized ? ' y finalizar' : ''} la conciliación. ¿Deseas continuar de todas formas?
        </p>
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onCancel}>Cancelar</button>
          <button className="btn btn-danger" onClick={onConfirm}>Continuar de todas formas</button>
        </div>
      </div>
    </div>
  );
}
